import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './session-transcripts.types';
import * as constants from './session-transcripts.constants';

export const sessionTranscriptsReducer = generateResourceReducer<types.ISessionTranscript>({
  STORE: constants.STORE_SESSION_TRANSCRIPT,
  CLEAR: constants.CLEAR_SESSION_TRANSCRIPT,
});
